export const ERRORS_CONSTANTS = {
  errors: {
    MC2000: {
      text: 'Ocurrió un error en la autenticación, por favor vuelva a intentar autenticarse, si el error persiste comuníquese con',
      code: 'MC-2000',
      phone: '(601) 3902670',
    },
  },
};
